import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilImage } from '@coreui/icons'
import React from 'react'
import { resolvePlayerImageUrl } from 'src/utils/imageUrl'
import SectionBox from './SectionBox'

const MAX_REVIEW_ROWS = 5

// players: { id, name, team_name, image, is_avatar }[]
const PlayerReviewTable = ({
  players,
  totalCount,
  newImagePreviewUrl,
  emptyMessage = 'No players selected yet',
}) => {
  const total = totalCount ?? players.length
  const visible = players.slice(0, MAX_REVIEW_ROWS)

  return (
    <SectionBox title="3. Review" className="mt-4">
      <div className="ge-datatable ge-datatable--static">
        <CTable responsive hover className="align-middle mb-0">
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell>Player</CTableHeaderCell>
              <CTableHeaderCell>Team</CTableHeaderCell>
              <CTableHeaderCell>Current Image</CTableHeaderCell>
              <CTableHeaderCell>New Image</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {visible.length === 0 && (
              <CTableRow>
                <CTableDataCell colSpan={4} className="text-medium-emphasis text-center">
                  {emptyMessage}
                </CTableDataCell>
              </CTableRow>
            )}
            {visible.map((item) => {
              const currentImageUrl = resolvePlayerImageUrl(item)
              return (
                <CTableRow key={item.id}>
                  <CTableDataCell>{item.name}</CTableDataCell>
                  <CTableDataCell>{item.team_name || '-'}</CTableDataCell>
                  <CTableDataCell>
                    {currentImageUrl ? (
                      <img
                        src={currentImageUrl}
                        alt="Current"
                        width={40}
                        height={40}
                        style={{ objectFit: 'cover', borderRadius: 6 }}
                      />
                    ) : (
                      <CIcon icon={cilImage} className="text-medium-emphasis" size="xl" />
                    )}
                  </CTableDataCell>
                  <CTableDataCell>
                    {newImagePreviewUrl ? (
                      <img
                        src={newImagePreviewUrl}
                        alt="New"
                        width={40}
                        height={40}
                        style={{ objectFit: 'cover', borderRadius: 6 }}
                      />
                    ) : (
                      <CIcon icon={cilImage} className="text-medium-emphasis" size="xl" />
                    )}
                  </CTableDataCell>
                </CTableRow>
              )
            })}
          </CTableBody>
        </CTable>
      </div>
      {total > MAX_REVIEW_ROWS && (
        <div className="text-medium-emphasis small mt-2">
          Showing {MAX_REVIEW_ROWS} of {total} matched players
        </div>
      )}
    </SectionBox>
  )
}

export default PlayerReviewTable
